import { Skeleton } from '@/components/ui/skeleton';

export default function NewsCardSkeleton() {
  return (
    <div className='flex flex-col gap-6'>
      <Skeleton className='h-64 w-full' />
      <div className='flex flex-col gap-4'>
        <Skeleton className='h-6 w-1/2' />
        <Skeleton className='h-6 line-clamp-2' />
      </div>
      <Skeleton className='h-6 w-1/3 self-end mt-3 lg:mt-4' />
    </div>
  );
}
